<template>
    <div
        v-if="consultations"
        class="container-fluid adminGroupConsultationsWrapper">
        <div class="d-block d-md-flex justify-content-between mb-3">
            <div class="d-block d-md-flex flex-wrap align-items-center">
                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                    <div class="input-group input-group-sm">
                        <select
                            v-model="search.medical_course_id"
                            @change="onChangeSearchMedicalCourseId"
                            style="min-width: 100px;"
                            class="form-control">
                            <option :value="null">{{ $locale.consultation_host }}科で検索</option>
                            <option
                                v-for="course in medicalCourses"
                                :value="course.id">
                                {{ course.name }}
                            </option>
                            <option value="all">すべての{{ $locale.consultation_host }}科</option>
                        </select>
                    </div>
                </div>

                <div
                    v-if="isOrganization"
                    class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                    <div class="input-group input-group-sm">
                        <select
                            v-model="search.child_group_id"
                            @change="onChangeSearchChildGroupId"
                            id="status"
                            style="min-width: 100px;"
                            class="form-control">
                            <option :value="null">{{ `${helper.groupTypeName(childGroupsType)}で検索` }}</option>
                            <option
                                v-for="childGroup in group.child_groups"
                                :value="childGroup.id">
                                {{ childGroup.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                    <div class="input-group input-group-sm">
                        <select
                            v-model="search.status"
                            @change="onChangeSearchStatus"
                            id="status"
                            style="min-width: 100px;"
                            class="form-control">
                            <option :value="null">ステータスで検索</option>
                            <option value="reserved">予約</option>
                            <option value="hold">{{ $locale.consultation_host }}中</option>
                            <option value="end-all">{{ $locale.consultation_host }}終了（全）</option>
                            <option value="no-report">{{ $locale.consultation_host }}終了（未）</option>
                            <option value="reported">{{ $locale.consultation_host }}終了（記）</option>
                            <option value="cancel">キャンセル（全）</option>
                            <option value="cancel_by_patient">キャンセル（{{ $locale.patient.substr(0, 1) }}）</option>
                            <option value="cancel_by_doctor">キャンセル（医）</option>
                            <option value="all">すべてのステータス</option>
                        </select>
                    </div>
                </div>

                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                    <div class="c-freeword input-group input-group-sm">
                        <input
                            v-model="search.freeword"
                            @blur="onChangeSearchFreeword"
                            type="text"
                            class="form-control"
                            placeholder="フリーワード"
                            style="min-width: 100px;">
                        <div class="input-group-append">
                            <div class="c-freeword__btn input-group-text"
                                 @click="onChangeSearchFreeword">検索
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-block d-md-flex align-items-center">
                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                        <span class="small">{{ $locale.consultation_host }}日</span>
                    </div>
                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                        <div class="c-freeword input-group input-group-sm">
                            <input
                                v-model="search.start_time"
                                @change="onChangeSearchStartTime"
                                type="date"
                                class="form-control"
                                aria-label="Recipient's username"
                                aria-describedby="basic-addon2"
                                style="min-width: 100px;">
                        </div>
                    </div>
                    <span class="small mt-2 ml-2">〜</span>
                    <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                        <div class="c-freeword input-group input-group-sm">
                            <input
                                v-model="search.end_time"
                                @change="onChangeSearchEndTime"
                                type="date"
                                class="form-control"
                                aria-label="Recipient's username"
                                aria-describedby="basic-addon2"
                                style="min-width: 100px;">
                        </div>
                    </div>
                </div>

                <div class="mt-2 mr-0 ml-0 mb-2 mr-md-2 ml-md-3 mb-md-0">
                    <div class="custom-control custom-checkbox mt-2">
                        <input
                            v-model="search.is_only_health_package"
                            id="is_only_health_package"
                            class="custom-control-input"
                            type="checkbox"
                            @change="onChangeSearchIsOnlyHealthPackage">
                        <label
                            class="custom-control-label"
                            for="is_only_health_package">
                            健康管理パッケージの{{ $locale.consultation_host }}のみ表示
                        </label>
                    </div>
                </div>
            </div>

            <div class="mt-3 text-right">
                <b-button
                    variant="yokumiru-orange"
                    @click="downloadCSV"
                    :disabled="inProgress"
                    style="min-width: 142px;">
                    CSVダウンロード
                </b-button>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="d-flex flex-wrap mt-3 mb-1">
                    <div class="reservedNotice small mr-2">
                        <div></div>
                        <div>&nbsp;:&nbsp;医師による予約</div>
                    </div>
                    <div class="reservedNotice reservedNoticeMatching small mr-2">
                        <div></div>
                        <div>&nbsp;:&nbsp;マッチング予約</div>
                    </div>
                    <div class="d-flex align-items-center small mr-2">
                        <div class="reservedLabel">再</div>
                        <div>&nbsp;:&nbsp;再{{ $locale.consultation_host }}</div>
                    </div>
                    <div class="d-flex align-items-center small mr-2">
                        <div class="reservedLabel reservedLabelDraftCancel">ド</div>
                        <div>&nbsp;:&nbsp;ドラフト経由（前回キャンセル）</div>
                    </div>
                    <div class="d-flex align-items-center small">
                        <div class="reservedLabel reservedLabelDraftDoctor">ド</div>
                        <div>&nbsp;:&nbsp;ドラフト経由（医師の依頼）</div>
                    </div>
                </div>

                <b-table
                    striped
                    hover
                    responsive
                    :items="consultations"
                    :fields="fields"
                    :sort-by.sync="morphState.sortBy"
                    :sort-desc.sync="morphState.sortDesc"
                    @sort-changed="fetchConsultations"
                    class="table-bordered m-table">
                    <template v-slot:cell(id)="data">
                        <div :class="{
                            'reservedByDoctor' : Number(data.item.flg_reserved_by_doctor) === 1,
                            'reservedByMatching' : Number(data.item.is_matching_reserved) === 1,
                        }">
                            {{ data.item.id }}
                        </div>
                    </template>

                    <template v-slot:cell(start_time)="data">
                        <div>
                            <span>{{ helper.dateForHuman(data.item.start_time, timezone, { simpleYear: true }) }}</span>
                            <span class="small font-weight-bold"
                                  :class="helper.dayForHumanCSS(data.item.start_time, timezone)">
                                {{ helper.dayForHuman(data.item.start_time, timezone, { bracket: true }) }}
                            </span>
                        </div>
                        <div>
                            <span>{{ helper.timeForHuman(data.item, timezone) }}</span>
                            <span>{{ helper.consultationOrder(data.item, consultations) }}</span>
                        </div>
                        <timezone-box
                            v-if="data.item.user && data.item.user.timezone !== 'Asia/Tokyo'"
                            :consultation="data.item"
                            :timezone="data.item.user.timezone"
                            as-user>
                        </timezone-box>
                        <timezone-box
                            v-if="data.item.doctor && data.item.doctor.timezone !== 'Asia/Tokyo'"
                            :consultation="data.item"
                            :timezone="data.item.doctor.timezone"
                            as-doctor>
                        </timezone-box>
                    </template>

                    <template v-slot:cell(medical_courses.name)="data">
                        <template v-if="data.item.doctor_menu">
                            <div style="line-height:1.3; margin-top:2px;">
                                {{ data.item.medical_course.name }}
                            </div>
                            <div
                                v-if="data.item.doctor_menu.is_health_package"
                                class="doctorMenuHealthPackageIcon">
                                <img src="/images/common/label_health_package1.png">
                            </div>
                            <a href="#" @click="showModalDoctorMenu(data.item.doctor_menu_id, $event)">
                                {{ data.item.doctor_menu.title }}
                            </a>
                            <div
                                v-if="data.item.is_repeat_reserved"
                                class="reservedLabel">
                                再
                            </div>
                            <div
                                v-if="data.item.reserved_as === 'DRAFT_CANCEL' || data.item.reserved_as === 'DRAFT_DOCTOR'"
                                :class="{
                                    'reservedLabelDraftCancel' : data.item.reserved_as === 'DRAFT_CANCEL',
                                    'reservedLabelDraftDoctor' : data.item.reserved_as === 'DRAFT_DOCTOR',
                                }"
                                class="reservedLabel">
                                ド
                            </div>
                        </template>
                        <template v-else>
                            <div>{{ data.item.medical_course.name }}</div>
                        </template>
                    </template>

                    <template v-slot:cell(doctors.full_name_kana)="data">
                        <template v-if="data.item.doctor">
                            <a href="#" @click="showModalDoctorProfile(data.item.doctor_id, $event)">
                                {{ data.item.doctor.full_name }}
                            </a>
                            <div class="small">{{ data.item.doctor.full_name_kana }}</div>
                        </template>
                        <template v-else-if="data.item.doctor_id === null">
                            <span class="text-muted">未定</span>
                        </template>
                        <template v-else>
                            <span class="text-muted">退会済の医師</span>
                        </template>
                    </template>

                    <template v-slot:cell(join_users.full_name_kana)="data">
                        <template v-if="data.item.user">
                            <a href="#" @click="showModalUserProfile(data.item.user_id, $event)">
                                {{ data.item.user.full_name }}
                            </a>
                            <div class="small">{{ data.item.user.full_name_kana }}</div>
                        </template>
                        <template v-else>
                            <span class="text-muted">退会済の{{ $locale.patient }}</span>
                        </template>
                    </template>

                    <template v-slot:cell(child_groups.name_kana)="data">
                        <div v-if="data.item.child_group !== null">
                            <a :href="`/${helper.groupTypeModel(group.group_type)}/groups/${data.item.child_group.id}`">
                                {{ data.item.child_group.name }}
                            </a>
                        </div>
                    </template>

                    <template v-slot:cell(plan_id)="data">
                        <div>{{ data.item.plan.name }}</div>
                    </template>

                    <template v-slot:cell(status)="data">
                        <div
                            class="c-indicator"
                            :class="detectStatusCSS( data.item )">
                            <span>{{ detectStatusName(data.item) }}</span>
                            <span>/</span>
                            <span>{{ detectStatusNameMedicalRecord(data.item) }}</span>
                        </div>
                        <div class="d-flex mt-1">
                            <div
                                v-show="data.item.messages_count > 0"
                                class="c-counter-badge mr-2">
                                <b-icon-chat-dots-fill></b-icon-chat-dots-fill>
                            </div>
                            <div
                                v-show="data.item.images_count > 0"
                                class="c-counter-badge mr-2">
                                <img src="/images/common/icon_camera2_bk.svg" style="width: 14px; position: relative; top: -1px;">
                                <span class="c-counter-badge__item">{{ data.item.images_count }}</span>
                            </div>
                            <div
                                v-show="data.item.attached_images_count > 0"
                                class="c-counter-badge">
                                <b-icon-images></b-icon-images>
                                <span class="c-counter-badge__item">{{ data.item.attached_images_count }}</span>
                            </div>
                        </div>
                        <div
                            v-if="data.item.flg_cancel || isAbsence(data.item)"
                            class="cancelReasonWrapper"
                            :class="{ 'cancelReasonWrapperAbsence' : isAbsence(data.item) }">
                            <div class="cancelReasonHeading">
                                <div>{{ cancelReasonHeadingText(data.item) }}</div>
                            </div>
                            <div class="cancelReasonContent">
                                <div class="cancelReasonDatetime d-flex justify-content-between">
                                    <div>
                                        {{ `キャンセル日時${helper.dateTimeForHuman(isAbsence(data.item) ? data.item.finished_at : data.item.canceled_at, timezone)}` }}
                                    </div>
                                    <img
                                        src="/images/common/icon-magnifying-glass.svg"
                                        @click="onClickCancelReason(data.item)">
                                </div>
                                <div
                                    v-if="isRequiredCancelReason(data.item)"
                                    class="cancelReason text-danger font-weight-bold">
                                    ※キャンセル事由：未回答
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:cell(estimated_total)="data">
                        <div v-if="data.item.doctor_menu && data.item.doctor_menu.is_health_package">
                            <!-- 健康管理パッケージの場合は金額非表示 -->
                        </div>
                        <div v-else-if="data.item.estimated_total !== null">
                            {{ data.item.estimated_total.toLocaleString() }}円
                        </div>
                        <div v-else-if="data.item.invoice">
                            {{ data.item.invoice.total.toLocaleString() }}円
                        </div>
                    </template>

                    <template v-slot:cell(medical_records.published_at)="data">
                        <div
                            v-if="data.item.medical_record && data.item.medical_record.published_at"
                            class="u-palt">
                            <span>
                                {{ helper.dateForHuman(data.item.medical_record.published_at, timezone, { simpleYear: true }) }}
                            </span>
                            <span
                                class="small font-weight-bold"
                                :class="helper.dayForHumanCSS(data.item.medical_record.published_at, timezone)">
                                {{ helper.dayForHuman(data.item.medical_record.published_at, timezone, { bracket: true }) }}
                            </span>
                            <span>{{ helper.timeForHuman(data.item.medical_record.published_at, timezone) }}</span>
                        </div>
                    </template>

                    <template v-slot:head(consultation_feedback.status)="data">
                        <div class="small font-weight-bold">フィードバックの<br>ステータス</div>
                    </template>
                    <template v-slot:cell(consultation_feedback.status)="data">
                        <div
                            v-if="data.item.consultation_feedback && data.item.consultation_feedback.status !== null"
                            class="feedbackLabel"
                            :style="feedbackLabel(data.item.consultation_feedback).css">
                            {{ feedbackLabel(data.item.consultation_feedback).text }}
                        </div>
                    </template>

                    <template v-slot:cell(consultation_feedback.next_schedule)="data">
                        <div v-if="data.item.consultation_feedback" class="feedbackNextSchedule">{{ data.item.consultation_feedback.next_schedule }}</div>
                    </template>

                    <template v-slot:cell(consultation_detail)="data">
                        <b-button
                            v-if="data.item.consultation_feedback && data.item.consultation_feedback.published_at !== null"
                            class="btn btn-info btn-sm"
                            variant="yokumiru-dark-green"
                            @click="downloadFeedback(data.item)"
                            :disabled="inProgress">
                            記録をダウンロード
                        </b-button>
                    </template>
                </b-table>

                <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <b-pagination
                        :total-rows="morphState.total"
                        :per-page="morphState.per_page"
                        v-model="morphState.current_page"
                        @change="fetchConsultations">
                    </b-pagination>

                    <div class="d-flex flex-wrap align-items-center">
                        <div class="mr-3 mb-3">
                            <span class="small">{{ dispPaginationDetail }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'
import {sprintf} from 'sprintf-js'
import moment from 'moment-timezone'
import {mapMutations} from 'vuex'

export default {
    name: 'AdminGroupConsultations',

    props: {
        medicalCourses: {
            type: Array,
            required: true,
        },
        group: {
            type: Object,
            required: true,
        },
        parentGroup: {
            type: Object,
            default: null,
        },
        childGroupsType: {
            type: Number,
            default: null,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            search: {
                freeword: null,
                medical_course_id: null,
                child_group_id: null,
                status: null,
                start_time: null,
                end_time: null,
                is_only_health_package: false,
            },
            consultations: null,
            consultationStatus: constants.consultations,
            feedbackStatusAll: constants.consultation_feedback.all,
            timezone: 'Asia/Tokyo',
            inProgress: false,
            errors: {},
            fields: [
                {
                    key: 'id',
                    label: '#',
                    sortable: true,
                },
                {
                    key: 'start_time',
                    label: `${this.$locale.consultation_host}日時`,
                    sortable: true,
                },
                {
                    key: 'medical_courses.name',
                    label: `${this.$locale.consultation_host}科・メニュー`,
                    sortable: true,
                },
                {
                    key: 'doctors.full_name_kana',
                    label: '医師',
                    sortable: true,
                },
                {
                    key: 'join_users.full_name_kana',
                    label: this.$locale.patient,
                    sortable: true,
                },
                {
                    'key': 'plan_id',
                    'label': 'サービスモデル',
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'ステータス',
                    sortable: true,
                },
                {
                    key: 'estimated_total',
                    label: '金額',
                    sortable: true,
                },
                {
                    key: 'medical_records.published_at',
                    label: '記録公開日時',
                    sortable: true,
                },
                {
                    key: 'consultation_feedback.status',
                    label: 'フィードバックのステータス',
                    sortable: true,
                },
                {
                    key: 'consultation_feedback.next_schedule',
                    label: `次回${this.$locale.consultation_host}予定`,
                    sortable: false,
                },
                {
                    key: 'consultation_detail',
                    label: '',
                    class: 'text-center',
                    sortable: false,
                }
            ],
        }
    },

    computed: {
        isCompany: function () {
            return this.helper.isCompany(this.group)
        },

        isOrganization: function () {
            return this.helper.isOrganization(this.group)
        },

        morphState: function () {
            if (this.isCompany) {
                return this.$store.state.adminCompanyConsultations
            }
            else if (this.isOrganization) {
                return this.$store.state.adminOrganizationConsultations
            }
            return null
        },

        /**
         * ページング詳細表示
         * @returns {string}
         */
        dispPaginationDetail: function () {
            if (this.morphState.total < 1) {
                return ''
            }

            return `全${this.morphState.total}件中 ${this.morphState.from}～${this.morphState.to}件表示`
        },
    },

    created: function () {
        this.initQueryFromState()
        this.initSearchCondition()
        this.fetchConsultations()

        if (this.childGroupsType !== null) {
            this.fields.splice(5, 0, {
                key: 'child_groups.name_kana',
                label: this.helper.groupTypeName(this.childGroupsType),
                sortable: true,
            })
        }
    },

    methods: {
        ...mapMutations({
            setQueryCompany: 'adminCompanyConsultations/setQuery',
            setQueriesCompany: 'adminCompanyConsultations/setQueries',
            setQueryOrganization: 'adminOrganizationConsultations/setQuery',
            setQueriesOrganization: 'adminOrganizationConsultations/setQueries',
        }),

        setQuery: function (data) {
            if (this.isCompany) {
                this.setQueryCompany(data)
            }
            else if (this.isOrganization) {
                this.setQueryOrganization(data)
            }
        },

        setQueries: function (data) {
            if (this.isCompany) {
                this.setQueriesCompany(data)
            }
            else if (this.isOrganization) {
                this.setQueriesOrganization(data)
            }
        },

        /**
         * 検索条件の初期化
         */
        initQueryFromState: function () {
            if (localStorage.getItem('yokumiruWeb')) {
                const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                if (this.isCompany && data.adminCompanyConsultations) {
                    this.setQueries(data.adminCompanyConsultations)
                }
                else if (this.isOrganization && data.adminOrganizationConsultations) {
                    this.setQueries(data.adminOrganizationConsultations)
                }
            }
        },

        /**
         * 検索条件の初期化
         */
        initSearchCondition: async function () {
            this.search.freeword = this.morphState.freeword
            this.search.medical_course_id = this.morphState.medical_course_id
            this.search.child_group_id = this.morphState.child_group_id
            this.search.status = this.morphState.status
            this.search.start_time = this.morphState.start_time
            this.search.end_time = this.morphState.end_time
            this.search.is_only_health_package = this.morphState.is_only_health_package

            // 検索する子グループが存在しない場合
            if (!this.group.child_groups || this.group.child_groups.every((group) => group.id !== this.search.child_group_id)) {
                this.search.child_group_id = null
                await this.setQuery({ key: 'child_group_id', value: null })
            }

            // 健康管理パッケージを利用しない場合
            if (!this.group.is_health_package) {
                this.search.is_only_health_package = false
                await this.setQuery({ key: 'is_only_health_package', value: false })
            }
        },

        onChangeSearchFreeword: async function () {
            await this.setQuery({ key: 'freeword', value: this.search.freeword })
            await this.fetchConsultations(1)
        },

        onChangeSearchMedicalCourseId: async function () {
            await this.setQuery({ key: 'medical_course_id', value: this.search.medical_course_id })
            await this.fetchConsultations(1)
        },

        onChangeSearchChildGroupId: async function () {
            await this.setQuery({ key: 'child_group_id', value: this.search.child_group_id })
            await this.fetchConsultations(1)
        },

        onChangeSearchStatus: async function () {
            await this.setQuery({ key: 'status', value: this.search.status })
            await this.fetchConsultations(1)
        },

        onChangeSearchStartTime: async function () {
            await this.setQuery({ key: 'start_time', value: this.search.start_time })
            await this.fetchConsultations(1)
        },

        onChangeSearchEndTime: async function () {
            await this.setQuery({ key: 'end_time', value: this.search.end_time })
            await this.fetchConsultations(1)
        },

        onChangeSearchIsOnlyHealthPackage: async function () {
            await this.setQuery({ key: 'is_only_health_package', value: this.search.is_only_health_package })
            await this.fetchConsultations(1)
        },

        /**
         * 相談一覧取得
         *
         * @param {number|object} param
         */
        fetchConsultations: async function (param = null) {
            if (this.inProgress) return
            this.inProgress = true

            this.consultations = null

            if (Number.isInteger(param) && param > 0) {
                await this.setQuery({ key: 'current_page', value: param })
            }
            else if (param !== null && param.hasOwnProperty('sortBy')) {
                await this.setQuery({ key: 'sortBy', value: param.sortBy })
                await this.setQuery({ key: 'sortDesc', value: param.sortDesc })
            }

            const endpoint = constants.admin.consultations.endpoint.base

            await axios.get(`${endpoint}${this.buildQuery()}`)
                .then(({data}) => {
                    this.consultations = data.data
                    this.setQueries(data.meta)
                })

            this.inProgress = false
        },

        /**
         * QueryString生成
         *
         * @param {boolean} paginate
         * @return {string}
         */
        buildQuery: function (paginate = true) {
            let query = '?'

            const state = this.morphState

            if (paginate) {
                query += `page=${state.current_page}`
                query += `&sort=${state.sortBy}`
                query += `&desc=${state.sortDesc}`
            }
            else {
                query += `sort=${state.sortBy}`
                query += `&desc=${state.sortDesc}`
            }

            if (state.freeword.length > 0) {
                query += `&freeword=${state.freeword}`
            }
            if (state.medical_course_id) {
                query += `&medical_course_id=${state.medical_course_id}`
            }
            if (state.status) {
                query += `&status=${state.status}`
            }
            if (state.start_time) {
                query += `&start_time=${ moment(state.start_time).set({'hour' : 0 , 'minute' : 0 , 'second' : 0 }).format( 'YYYY-MM-DD HH:mm:ss' ) }`;
            }
            if (state.end_time) {
                query += `&end_time=${ moment(state.end_time).set({'hour' : 23 , 'minute' : 59 , 'second' : 59 }).format( 'YYYY-MM-DD HH:mm:ss' ) }`;
            }
            if (state.is_only_health_package) {
                query += '&is_only_health_package=1'
            }

            if (this.parentGroup === null) {
                query += `&group_id=${this.group.id}`

                if (state.child_group_id) {
                    query += `&child_group_id=${state.child_group_id}`
                }
            }
            else {
                query += `&child_group_id=${this.group.id}`
            }

            return query
        },

        /**
         * ステータス表記
         *
         * @param {object} consultation
         * @return {string}
         */
        detectStatusCSS: function (consultation) {
            const result = this.consultationStatus.all.find(status => {
                return status.value === consultation.status
            })

            // 診療終了
            if (result.value === this.consultationStatus.finished) {
                if (!consultation.medical_record ||
                    !consultation.medical_record.body ||
                    consultation.medical_record.body.length < 1) {
                    return 'c-indicator--yellow'
                }
            }
            return result.css
        },

        /**
         * ステータス表記
         *
         * @param {object} consultation
         * @return {string}
         */
        detectStatusName: function (consultation) {
            let result = this.consultationStatus.all.find(status => {
                return status.value === consultation.status
            })

            if (this.$locale.type === 'consul') {
                result.text = result.text.replace('診療', '相談')
                result.text = result.text.replace('患者', '会員')
            }

            // キャンセル
            if (consultation.flg_cancel == 1) {
                if (constants.consultations.cancelAll.includes(result.value)) {
                    return result.text
                }
                if (consultation.flg_cancel_by_doctor == 1) {
                    return 'キャンセル（医師）'
                }
                return this.$locale.type === 'consul' ? 'キャンセル（会員）' : 'キャンセル（患者）'
            }

            // その他
            return result.text
        },

        /**
         * ステータス表記（相談記録）
         *
         * @param {object} consultation
         * @return {string}
         */
        detectStatusNameMedicalRecord: function (consultation) {
            if (consultation.medical_record && consultation.medical_record.published_at) {
                return '記録公開済'
            }
            return '記録未公開'
        },

        /**
         * フィードバックのステータス名
         *
         * @param {object} feedback
         * @return {object}
         */
        feedbackLabel: function (feedback) {
            const label = this.feedbackStatusAll.find((status) => {
                return Number(status.value) === Number(feedback.status)
            })

            return label || {}
        },

        /**
         * 医師メニュー詳細モーダル表示
         *
         * @param {number} doctor_menu_id
         * @param {object} e
         */
        showModalDoctorMenu: function (doctor_menu_id, e) {
            e.preventDefault()
            bus.$emit('open-modal-doctor-menu', doctor_menu_id)
        },

        /**
         * 医師詳細モーダル表示
         *
         * @param {object} doctor
         * @param {object} e
         */
        showModalDoctorProfile: function (doctor, e) {
            e.preventDefault()
            bus.$emit('open-modal-admin-doctor-profile', doctor)
        },

        /**
         * 会員詳細モーダル表示
         *
         * @param {number} userId
         * @param {object} e
         */
        showModalUserProfile: function (userId, e) {
            e.preventDefault()
            bus.$emit('open-modal-admin-user-profile', userId)
        },

        /**
         * CSVダウンロード
         */
        downloadCSV: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = `${constants.admin.consultations.endpoint.base}/export${this.buildQuery(false)}&group_id=${this.group.id}`
            const options = { responseType : 'blob' }

            await axios.get(endpoint, options)
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: response.data.type,
                    })
                    saveAs(
                        blob,
                        sprintf(
                            '%s_%s一覧_%s.csv',
                            this.group.name,
                            this.$locale.consultation_host,
                            moment().format('YYYYMMDD')
                        )
                    )
                })
                .catch(() => {
                    bus.$emit('alert-danger', 'システムエラーが発生しました。')
                })

            this.inProgress = false
        },

        /**
         * 法人フィードバック記録PDFダウンロード
         *
         * @param {object} consultation
         */
        downloadFeedback: async function (consultation) {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = `${constants.admin.consultation_feedback.endpoint.base}/${consultation.consultation_feedback.id}/export`
            const options = { responseType : 'blob' }

            await axios.get(endpoint, options)
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: response.data.type,
                    })
                    saveAs(
                        blob,
                        sprintf(
                            '#%s_%s記録表_%s.pdf',
                            consultation.id,
                            this.$locale.consultation_host,
                            moment().format('YYYYMMDD')
                        )
                    )
                })
                .catch(() => {
                    bus.$emit('alert-danger', 'システムエラーが発生しました。')
                })

            this.inProgress = false
        },

        /**
         * 未入室終了かどうか
         * @param {object} consultation
         * @return {boolean}
         */
        isAbsence: function (consultation) {
            return this.consultationStatus.absenceAll.includes(consultation.status)
        },

        /**
         * キャンセル事由の見出しテキスト
         * @param {object} consultation
         */
        cancelReasonHeadingText: function (consultation) {
            const status = consultation.status
            const patient = this.$locale.patient
            const consultationHost = this.$locale.consultation_host

            // 会員起因
            if (status === this.consultationStatus.canceledAuthUser) {
                return `${patient}による${consultationHost}24時間前以降のキャンセル`
            }
            else if (status === this.consultationStatus.absenceUser) {
                return `${patient}による未入室終了`
            }
            else if (status === this.consultationStatus.canceledUser) {
                return `${patient}によるキャンセル`
            }

            // 医師起因
            if (consultation.cancel_category === constants.cancelCategory.doctorLogin) {
                return `医師の予約未確認による自動キャンセル`
            }
            else if (status === this.consultationStatus.canceledAuthDoctor) {
                return `医師による${consultationHost}24時間前以降のキャンセル`
            }
            else if (status === this.consultationStatus.absenceDoctor) {
                return `医師による未入室終了`
            }
            else if (status === this.consultationStatus.canceledDoctor) {
                return '医師によるキャンセル'
            }
            return ''
        },

        /**
         * キャンセル事由の未回答判定
         * @param {object} consultation
         */
        isRequiredCancelReason: function (consultation) {
            // すでにキャンセル事由が記入済み
            if (consultation.cancel_reason !== null && consultation.cancel_reason !== '') {
                return false
            }
            return consultation.cancel_category === constants.cancelCategory.doctorLogin
                || consultation.status === this.consultationStatus.canceledAuthDoctor
                || consultation.status === this.consultationStatus.absenceDoctor
        },

        /**
         * キャンセル事由の虫眼鏡アイコン押下時
         * @param {object} consultation
         */
        onClickCancelReason: function (consultation) {
            bus.$emit('open-modal-consultation-cancel-info-modal', consultation)
        },
    },
}
</script>

<style lang="scss" scoped>
.reservedLabel {
    position: relative;
    top: -1px;
    display: inline-block;
    width: 18px;
    height: 18px;
    line-height: 18px;
    color: #fff;
    font-size: 10px;
    text-align: center;
    background-color: #e7a222;
    border-radius: 50%;

    &.reservedLabelDraftCancel {
        background-color: #7e7e7e;
    }
    &.reservedLabelDraftDoctor {
        background-color: #228ee7;
    }
}

.reservedNotice {
    display: flex;
    align-items: center;

    div:nth-child(1) {
        width: 16px;
        height: 12px;
        background: #244787;
        border-radius: 4px;
    }

    div:nth-child(2) {
        font-size: .7rem;
    }

    &.reservedNoticeMatching {
        div:nth-child(1) {
            background: #D95672;
        }
    }
}

.reservedByDoctor {
    display: inline-block;
    padding: 0 4px;
    color: #fff;
    background: #244787;
    border-radius: 4px;
}

.reservedByMatching {
    display: inline-block;
    padding: 0 4px;
    color: #fff;
    background: #D95672;
    border-radius: 4px;
}

.doctorMenuHealthPackageIcon {
    margin: 3px 0 1px;

    img {
        width: 130px;
    }
}

.feedbackLabel {
    width: 90px;
    margin: 0 auto;
    padding: 3px 0;
    border-radius: 20px;
    color: #fff;
    font-size: 13px;
    text-align: center;
    box-sizing: border-box;
}

.feedbackNextSchedule {
    overflow-x: scroll;
    white-space: pre;
    width: 160px;
    padding: 0 0 5px;
}

.cancelReasonWrapper {
    color: #424242;
    background: #FFF0E6;
    border-radius: 4px;

    .cancelReasonHeading {
        padding: 4px 8px;
        font-size: 11px;
        font-weight: bold;
        background: #F9D2B8;
        border-radius: 4px 4px 0 0;
    }

    .cancelReasonContent {
        padding: 4px 8px;
        font-size: 10px;

        .cancelReasonDatetime {
            img {
                cursor: pointer;
            }
        }
    }

    &.cancelReasonWrapperAbsence {
        background: #F3EEFE;

        .cancelReasonHeading {
            background: #D7C5FC;
        }
    }
}
</style>

<style lang="scss">
.adminGroupConsultationsWrapper {
    .b-table {
        min-width: 1500px;

        th, td {
            font-size: 0.75rem;
        }

        th {
            &:nth-child(9) {
                width: 140px;
            }

            &:nth-child(10) {
                width: 160px;
            }
        }
    }
}
</style>
